import React, { useEffect, useState } from 'react';
import '../styles/Chatbot.css';

const MOBILE_QUERY = '(max-width: 767px)';
// Sections whose buttons the robot could cover (Send Message, project cards)
const DIM_SECTIONS = ['#contact', '#projects'];

const Chatbot = () => {
  const [dimmed, setDimmed] = useState(false);
  const [bubbleHidden, setBubbleHidden] = useState(false);

  // On mobile, show the speech bubble for 4 seconds after load, then hide it
  useEffect(() => {
    if (!window.matchMedia(MOBILE_QUERY).matches) return undefined;
    const timer = setTimeout(() => setBubbleHidden(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  // Fade the robot while a covered section overlaps the bottom half of the viewport
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;
    const targets = DIM_SECTIONS.map(selector => document.querySelector(selector)).filter(Boolean);
    const visible = new Set();
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        setDimmed(visible.size > 0);
      },
      { rootMargin: '-50% 0px 0px 0px' }
    );
    targets.forEach(target => observer.observe(target));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Chat Button - Not Clickable */}
      <div
        className={`chatbot-button${dimmed ? ' is-dimmed' : ''}`}
        style={{ pointerEvents: 'none', cursor: 'default' }}
        aria-hidden="true"
      >
        <div className="chatbot-icon">
          <div className="sage-robot-icon-small">
            <div className="robot-head-small">
              <div className="robot-antenna-small"></div>
              <div className="robot-screen-small">
                <div className="robot-eye-small left-eye-small"></div>
                <div className="robot-eye-small right-eye-small"></div>
                <div className="robot-mouth-small"></div>
              </div>
            </div>
            <div className="robot-body-small">
              <div className="robot-chest-light-small"></div>
              <div className="robot-arm-small left-arm-small"></div>
              <div className="robot-arm-small right-arm-small"></div>
              <div className="robot-leg-small left-leg-small"></div>
              <div className="robot-leg-small right-leg-small"></div>
            </div>
          </div>
          <div className={`sage-floating-message${bubbleHidden ? ' is-hidden' : ''}`}>
            <div className="message-line-1">Hi I am Geetha</div>
            <div className="message-line-2">nice to meet you</div>
          </div>
        </div>
        <div className="chatbot-pulse"></div>
      </div>
    </>
  );
};

export default Chatbot;
